import {UserEntity} from '@app/shared/services/api/user-entity';
import {Type} from 'class-transformer';
import {UserEntityImpl} from "@shared/services/api/user-profile.service";

export type UserId = string;

export interface User {
  id: UserId;
  username: string;
  firstname: string;
  lastname: string;
  fullName: string;
  email: string;
  customer_id?: number;
  client_id?: number;
  contractor_id?: number;
  entity?: UserEntity;
}

export type UserOption = Pick<User, 'id' | 'fullName' | 'entity'>;

export class UserImpl implements User {
  id: UserId;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  customer_id?: number;
  client_id?: number;
  contractor_id?: number;
  @Type(() => UserEntityImpl)
  entity?: UserEntity;

  get fullName(): string {
    if (isUserMissing(this)) {
      return '<' + this.id + '>';
    }
    return [this.firstname, this.lastname].join(' ');
  }
}

export function isUserMissing(user: User): boolean {
  return user && user.firstname == null && user.lastname == null;
}
